import {
  Stack,
  Text,
  Image,
  SimpleGrid,
  Box,
  Heading,
  StackDivider,
  Button,
  Flex,
} from "@chakra-ui/react";
import React from "react";

export default function BuyersPanel() {
  return (
    <Stack
      mb={10}
      gap={20}
      divider={<StackDivider borderColor="gray.200" />}
      border="1px"
      borderColor="gray.200"
      borderRadius={10}
      p={20}
    >
      <Box>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "27px" }}
          mb={10}
          textAlign={{ base: "center", md: "start" }}
        >
          Popular Topics
        </Heading>
        <SimpleGrid
          columns={{ base: 1, sm: 2, lg: 3, "2xl": 4 }}
          width={"full"}
          gap={{ base: 8, xl: 16 }}
        >
          {data.map((item,index) => {
            return (
              <GigBox
                title={item.title}
                imageUrl={item.imageUrl}
                key={index}
              />
            );
          })}
        </SimpleGrid>
      </Box>
      <Box>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "27px" }}
          mb={10}
        >
          Recommended for you
        </Heading>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
          gap={{ base: 5, xl: 10 }}
          w="full"
        >
          {recommendationData.map((item,index) => {
            return (
              <CategoryBox
                label={item.title}
                description={item.description}
                jobs={item.jobs}
                key={index}
              />
            );
          })}
        </SimpleGrid>
      </Box>
      <Box>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "27px" }}
          mb={10}
        >
          Discover More Topics
        </Heading>
        <SimpleGrid columns={{ base: 2, md: 3, lg: 4, xl: 5 }} gap={10}>
          {moreTopicsData.map((item,index) => {
            return (
              <TopicBox
                title={item.title}
                links={item.links}
                key={index}
              />
            );
          })}
        </SimpleGrid>
        <Flex justifyContent="center" py={16}>
          <Button bg="brand.500" color="white" px={8} py={6}>
            View all topics
          </Button>
        </Flex>
        <Stack alignItems={"center"} gap={4} my={10}>
          <Heading
            color="gray.500"
            fontWeight={"bold"}
            fontSize={{ base: "24px", lg: "36px" }}
          >
            Still need help?
          </Heading>
          <Box>
            <Text color="gray.400" mb={4}>
              We're here for you
            </Text>
            <Button bg="brand.500" color="white" px={8} py={6}>
              Get Started
            </Button>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
}
const GigBox = ({ title, imageUrl }) => {
  return (
    <Stack
      py={{ base: 4, md: 10 }}
      w={{ base: "full", "2xl": "290px" }}
      cursor="pointer"
      bg="brand.900"
      height="full"
      borderRadius={"50px 0px 50px 0px"}
      justifyContent="center"
      alignItems="center"
    >
      <Image src={imageUrl} />
      <Text
        color="brand.800"
        fontWeight="semibold"
        py={4}
        fontSize={{ base: "12px", lg: "19px" }}
        px={2}
        textAlign="center"
      >
        {title}
      </Text>
    </Stack>
  );
};

const CategoryBox = ({ label, jobs, description }) => {
  return (
    <Stack
      alignItems="center"
      py={{ base: 5, md: 10 }}
      fontWeight={"bold"}
      borderRadius="20px"
      gap={{ base: 5, xl: 10 }}
      bg={"brand.600"}
      overflow="hidden"
    >
      <Stack height="full" width={"70%"} justifyContent="space-between">
        <Heading color="brand.800" fontSize={{ base: "21px", xl: "25px" }}>
          {label}
        </Heading>
        <Box height="60px" pt={{ base: 3, lg: 6 }}>
          <Text
            color="brand.300"
            textDecoration={description && "underline"}
            fontSize={{ md: "19px" }}
          >
            {jobs && jobs + " Job Posted"}
            {description && description}
          </Text>
        </Box>
      </Stack>
    </Stack>
  );
};
const TopicBox = ({ title, links }) => {
  return (
    <Box>
      <Text fontWeight="bold" fontSize="19px" color="#6a6a6a" height="90px">
        {title}
      </Text>
      <Stack gap={{ base: 2, md: 4 }} color="#757575">
        {links.map((item,index) => {
          return (
            <Text
              key={index}
              fontSize="14px"
              textDecoration="underline"
              href={item.href}
            >
              {item.label}
            </Text>
          );
        })}
      </Stack>
    </Box>
  );
};
const recommendationData = [
  {
    title: "How Fiverr works",
    description: "General account management",
  },
  {
    title: "Invoices",
    description: "Invoices",
  },
  {
    title: "Payment issues",
    description: "Payments",
  },
  {
    title: "Find a service and get a quote",
    description: "Buyer FAQs",
  },
  {
    title: "Paying for orders, Extras, or Custom Offers",
    description: "Payments",
  },
  {
    title: "Account and profile settings",
    jobs: 505,
  },
  {
    title: "Fiverr Business Freelancer and agency FAQ",
    jobs: 505,
  },
  {
    title: "Buyer FAQs",
    jobs: 505,
  },
];

const data = [
  {
    title: "Buyer Order Management",
    imageUrl: "/images/support/buyer.png",
  },
  {
    title: "Payments",
    imageUrl: "/images/support/payment.png",
  },
  {
    title: "Invoices",
    imageUrl: "/images/support/invoice.png",
  },
  {
    title: "Fiver Business",
    imageUrl: "/images/support/business.png",
  },
];

const moreTopicsData = [
  {
    title: "Order management",
    links: [
      {
        label: "Order communication",
        href: "#",
      },
      {
        label: "Buyer FAQs",
        href: "#",
      },
      {
        label: "Buyer Order Management",
        href: "#",
      },
      {
        label: "Seller Order Management",
        href: "#",
      },
    ],
  },
  {
    title: "Shutterstock integration",
    links: [
      {
        label: "Shutterstock for sellers",
        href: "#",
      },
      {
        label: "Shutterstock for buyers",
        href: "#",
      },
    ],
  },
  {
    title: "Buyer resource tools",
    links: [
      {
        label: "Maximizing your buyer",
        href: "#",
      },
      {
        label: "Experience",
        href: "#",
      },
      {
        label: "Podcasts",
        href: "#",
      },
    ],
  },
  {
    title: "Seller Hub",
    links: [
      {
        label: "Promoted Gigs",
        href: "#",
      },
      {
        label: "Seller Webinars",
        href: "#",
      },
    ],
  },
  {
    title: "Payments, Withdrawls, and Invoices",
    links: [
      {
        label: "Payment FAQ's",
        href: "#",
      },
      {
        label: "Payments",
        href: "#",
      },
      {
        label: "Invoices",
        href: "#",
      },
      {
        label: "Taxes",
        href: "#",
      },
    ],
  },
  {
    title: "Account and Security",
    links: [
      {
        label: "General account management",
        href: "#",
      },
      {
        label: "Creating an account",
        href: "#",
      },
      {
        label: "Account security",
        href: "#",
      },
    ],
  },
  {
    title: "Decolance Business",
    links: [
      {
        label: "FAQs",
        href: "#",
      },
    ],
  },
  {
    title: "Mobile App",
    links: [
      {
        label: "Order management",
        href: "#",
      },
      {
        label: "Payments and Withdrawals",
        href: "#",
      },
      {
        label: "Features",
        href: "#",
      },
    ],
  },
  {
    title: "Logo Maker",
    links: [
      {
        label: "Popular Questions",
        href: "#",
      },
      {
        label: "File Types",
        href: "#",
      },
      {
        label: "Branding Packages",
        href: "#",
      },
      {
        label: "Customizing your logo",
        href: "#",
      },
      {
        label: "How does the Logo Maker work?",
        href: "#",
      },
    ],
  },
  {
    title: "Logo Maker",
    links: [
      {
        label: "Popular Questions",
        href: "#",
      },
      {
        label: "File Types",
        href: "#",
      },
      {
        label: "Branding Packages",
        href: "#",
      },
      {
        label: "Customizing your logo",
        href: "#",
      },
      {
        label: "How does the Logo Maker work?",
        href: "#",
      },
    ],
  },
];
